import { useState, useEffect } from 'react';

export const useWindowSize = () => {
    const [ windowSize, setWindowSize ] = useState( {
        width: null,
        height: null,
    } );

    useEffect( () => {
        const handler = () => {
            setWindowSize( {
                width: window.innerWidth,
                height: window.innerHeight,
            } );
        };
        
        window.addEventListener( 'resize', handler );
        
        handler();
        
        return () => window.removeEventListener( 'resize', handler );
    }, [] );
    
    return windowSize;
};